import * as React from "react";
const SvgIcMinus = (props) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3 6L9 6", stroke: "currentColor", strokeWidth: 2.25, strokeLinecap: "round" }));
export default SvgIcMinus;
